import Store from './watcher';

let store = {};

if (!store.dialog) {
  store.dialog = new Store();
}

export default store;
